import type { Column, HeaderColumn, HeaderGroup, GetKeyFn } from "./types"

function getPlaceholderHeader(id: string) {
  return {
    id,
    Header: <span>&nbsp;</span>,
  }
}

function getColumnCount(columns: Column[]): number {
  return columns.reduce((count, col) => {
    const x = col.columns ? getColumnCount(col.columns) : 1
    return count + x
  }, 0)
}

function getHeaderGroupsDepth(columns: Column[]): number {
  let depth = 0
  columns.forEach((col) => {
    if (col.columns) {
      let cold = getHeaderGroupsDepth(col.columns) + 1
      depth = Math.max(cold, depth)
    }
  })
  return depth
}

function getHeader(column: Column): HeaderColumn {
  return {
    id: column.id,
    Header: column.Header,
    width: column.width,
    align: column.align,
    span: column.columns ? getColumnCount(column.columns) : 1,
    columns: column.columns,
    border: !!column.border ? column.border : "none",
  }
}

export function getHeaderGroups(columns: Column[]): HeaderGroup[] {
  const depth = getHeaderGroupsDepth(columns)
  const range = Array.from({ length: depth }, (_, i) => i)
  const groups: HeaderColumn[][] = [
    columns.filter((c) => !c.hidden).map(getHeader),
  ]
  range.forEach((i) => {
    const next = groups[i]
      .map((c, i) => c.columns ?? [getPlaceholderHeader(`${c.id}_${i}`)])
      .flat()
      .map(getHeader)

    groups.push(next)
  })
  return groups.map((columns, idx) => ({
    id: `header_group_${idx}`,
    headers: columns,
  }))
}

export function getDataColumns(columns: Column[]): Column[] {
  const visible = columns.filter((c) => !c.hidden)
  return flattenColumns(visible)
}

function flattenColumns(columns: Column[]) {
  const flat: Column[] = []
  const recurse = (arr: Column[]) => {
    arr.forEach((d) => {
      if (!d["columns"]) {
        flat.push(d)
      } else {
        recurse(d["columns"])
      }
    })
  }

  recurse(columns)
  return flat
}

export function getDefaultRowKey(row: any): string {
  const maybe_id = row["id"]
  if (typeof maybe_id !== "string") {
    throw new Error("fo")
  }
  return maybe_id
}

//
export function indexBy<T>(
  list: T[],
  getKey: GetKeyFn<T>,
): {
  records: Record<string, T>
  keys: string[]
} {
  const entries = list.map((it) => [getKey(it), it] as const)
  const records = Object.fromEntries(entries)
  const keys = entries.map((x) => x[0])
  return { records, keys }
}

export const getTrimmedId = (id: string) => id.split("_")?.[0]

export const sorted =
  (order?: string[]) => (a: Record<string, any>, b: Record<string, any>) =>
    (order || [])?.indexOf(getTrimmedId(a?.id)) -
    (order || [])?.indexOf(getTrimmedId(b?.id))
